(()=>{if(window.__a9f3c7)return;window.__a9f3c7=1;
const _c=v=>String(v||'').replace(/\u00a0/g,' ').replace(/\s+/g,' ').trim();
const _n=v=>_c(v).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9\s-]/g,' ');
const _h=v=>{const e=document.createElement('div');e.innerHTML=v||'';return _c(e.textContent||'')};
const _e=v=>window.CSS&&CSS.escape?CSS.escape(v):String(v).replace(/["\\]/g,'\\$&');

function _i(s){
  if(!s||s.dataset.zz==='1')return;
  s.dataset.zz='1';

  const q=s.querySelector('[data-z2]');
  const a=s.querySelector('[data-z4]');
  const t=s.querySelector('[data-z3]');
  const l=s.querySelector('[data-z5]');
  const f=s.querySelector('[data-zh]');
  const i=s.querySelector('[data-zi]');
  const b=s.querySelector('[data-zj]');
  const p=s.querySelector('[data-z8]');

  if(!q||!a||!t)return;

  const d=Math.max(600,parseInt(s.dataset.zb,10)||1300);
  const na=s.dataset.zd||"I couldn't find enough information about that in the product details currently available on this page.";
  const et=s.dataset.ze||'Please enter a product-related question.';
  const op=s.dataset.zf||'Ask a question...';

  let cb=s.dataset.zc||'';
  let ri=0;

  const sh=()=>`<span class="g5x8" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 1.8c.62 5.68 4.52 9.58 10.2 10.2-5.68.62-9.58 4.52-10.2 10.2C11.38 16.52 7.48 12.62 1.8 12 7.48 11.38 11.38 7.48 12 1.8Z" fill="currentColor"/></svg></span>`;

  function cp(x,y){
    const z=document.createElement('button');
    z.type='button';
    z.className='b9c1';
    z.setAttribute('data-z6','');
    if(y)z.setAttribute('data-z7',y);
    z.innerHTML=sh()+'<span></span>';
    z.querySelector('span:last-child').textContent=x;
    return z
  }

  function st(x){
    ri+=1;
    q.textContent=x;
    const z=q.closest('[data-z1]');
    if(z)z.classList.add('r9w1');
    return ri
  }

  function ra(x,y,z=true){
    q.textContent=x;
    if(z)a.innerHTML=y;
    else{
      a.innerHTML='<p></p>';
      a.querySelector('p').textContent=y
    }
    const w=q.closest('[data-z1]');
    requestAnimationFrame(()=>requestAnimationFrame(()=>{if(w)w.classList.remove('r9w1')}))
  }

  function mp(){
    const x=_c(q.textContent);
    if(!x||!l)return;
    const z=Array.from(l.querySelectorAll('[data-z6]')).some(v=>_c(v.textContent)===x);
    if(!z)l.prepend(cp(x,cb||''))
  }

  s.addEventListener('click',e=>{
    const x=e.target.closest('[data-z6]');
    if(!x||!s.contains(x))return;

    const y=x.getAttribute('data-z7')||'';
    const z=y?s.querySelector(`[data-z9][data-z7="${_e(y)}"]`):null;
    if(!z)return;

    const nq=_c(x.textContent);
    const hh=z.innerHTML.trim();

    mp();
    x.remove();

    const token=st(nq);

    window.setTimeout(()=>{
      if(token!==ri)return;
      cb=y;
      ra(nq,hh,true)
    },d)
  });

  const sw=new Set([
    'a','an','and','are','as','at','be','can','do','does','for','from','how',
    'i','in','is','it','me','my','of','on','or','our','please','product','should',
    'tell','the','this','to','use','what','when','where','which','who','why','with',
    'you','your'
  ]);

  const sg=[
    ['benefit','benefits','help','helps','purpose','result','results','effect','effects'],
    ['ingredient','ingredients','contain','contains','formula','formulated','made','active','actives'],
    ['use','using','apply','application','direction','directions','routine','take','taking','dose','dosage'],
    ['bright','brighten','brightening','glow','radiance','radiant','dull','dullness'],
    ['spot','spots','pigmentation','hyperpigmentation','blemish','blemishes','marks','uneven'],
    ['hydrate','hydration','hydrating','moisture','moisturize','dry','dryness'],
    ['hair','scalp','hairfall','fall','damage','damaged','breakage'],
    ['volume','strength','strong','healthy','health'],
    ['safe','safety','warning','warnings','caution','allergy','allergies','sensitive'],
    ['time','long','day','days','week','weeks','result','results','visible','notice']
  ];

  function tk(v){
    const w=_n(v).split(/\s+/).filter(Boolean);
    const r=new Set;
    w.forEach(x=>{
      if(x.length<=2||sw.has(x))return;
      r.add(x);
      sg.forEach(g=>{
        if(g.includes(x))g.forEach(y=>r.add(y))
      })
    });
    return Array.from(r)
  }

  function ss(v){
    return _c(v).split(/(?<=[.!?])\s+(?=[A-Z0-9])/).map(_c).filter(x=>x.length>=15)
  }

  function bs(){
    const r=[];

    if(p){
      const h=document.createElement('div');
      h.appendChild(p.content.cloneNode(true));

      let g=s.dataset.zg||'';
      const n=h.querySelectorAll('h1,h2,h3,h4,h5,h6,p,li,td,th');

      if(n.length){
        n.forEach(x=>{
          const y=_c(x.textContent);
          if(!y)return;

          if(/^H[1-6]$/.test(x.tagName)){
            g=y;
            return
          }

          ss(y).forEach(v=>r.push({title:g,text:v,type:'description'}))
        })
      }
    }

    s.querySelectorAll('[data-z9]').forEach(x=>{
      const y=_c(x.getAttribute('data-za'));
      const z=_h(x.innerHTML);
      ss(z).forEach(v=>r.push({title:y,text:v,type:'block'}))
    });

    return r
  }

  const src=bs();

  function sc(x,y,z){
    const a=_n(x.title);
    const b=_n(x.text);
    const c=_n(z);
    let d=0;

    y.forEach(v=>{
      if(a.includes(v))d+=7;
      if(b.includes(v))d+=2
    });

    if(/(ingredient|contain|formula|made)/.test(c)&&/(ingredient|formula|contain|active)/.test(a+' '+b))d+=14;
    if(/(benefit|help|purpose|good for|what does)/.test(c)&&/(benefit|help|support|improve|reduce|hydrate|bright|smooth|strength|volume)/.test(a+' '+b))d+=11;
    if(/(how.*use|how.*apply|direction|routine|dose|dosage|take)/.test(c)&&/(how to use|use|apply|direction|routine|take|dose)/.test(a+' '+b))d+=15;
    if(/(safe|warning|caution|allergy|sensitive)/.test(c)&&/(safe|warning|caution|allergy|sensitive|avoid|consult)/.test(a+' '+b))d+=14;
    if(/(how long|when.*result|time|days|weeks)/.test(c)&&/(day|days|week|weeks|result|results|visible|notice)/.test(a+' '+b))d+=12;
    if(x.type==='block')d+=1;

    return d
  }

  function fa(x){
    const y=tk(x);
    if(!y.length)return '';

    const z=src
      .map(v=>({...v,score:sc(v,y,x)}))
      .filter(v=>v.score>=3)
      .sort((a,b)=>b.score-a.score);

    if(!z.length)return '';

    const best=z[0].score;
    const out=[];
    const seen=new Set;
    let total=0;

    for(const v of z){
      if(out.length&&v.score<best*.42)break;

      const k=_n(v.text);
      if(!k||seen.has(k))continue;
      if(total+v.text.length>650&&out.length)break;

      out.push(v.text);
      seen.add(k);
      total+=v.text.length;

      if(out.length>=3)break
    }

    return _c(out.join(' '))
  }

  if(f&&i){
    f.addEventListener('submit',e=>{
      e.preventDefault();

      const x=_c(i.value);

      if(!x){
        i.placeholder=et;
        i.focus();
        window.setTimeout(()=>{i.placeholder=op},1800);
        return
      }

      mp();
      cb='';

      const token=st(x);
      if(b)b.disabled=true;

      window.setTimeout(()=>{
        if(token!==ri)return;

        const y=fa(x);
        ra(x,y||na,false);

        i.value='';
        if(b)b.disabled=false;

        const z=q.getBoundingClientRect().top+window.scrollY-110;
        window.scrollTo({top:Math.max(0,z),behavior:'smooth'})
      },d)
    })
  }
}

function _a(r=document){
  r.querySelectorAll('[data-z0]').forEach(_i)
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>_a(),{once:true})
}else{
  _a()
}

document.addEventListener('shopify:section:load',e=>{
  if(e.target&&e.target.matches&&e.target.matches('[data-z0]'))_i(e.target);
  else if(e.target)_a(e.target)
});
})();